module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_brand2.1b9277e2fb39abd5a9b0e749c2160a36.png";